<template>
  <div
    v-if="state"
    class="san-searchbox"
  >
    <slot
      :current-refinement="currentRefinement"
      :is-search-stalled="state.isSearchStalled"
      :refine="state.refine"
    >
      <SanFieldSearch
        v-model="currentRefinement"
        class="san-field-searchbox"
        name="search-input"
        :placeholder="placeholder"
        :autofocus="autofocus"
        :loading="isLoading || state.isSearchStalled"
        dense
        @focus="emit('focus', $event)"
        @blur="emit('blur', $event)"
        @clear="emit('clear')"
      >
        <!-- <template #prepend>
          <q-icon name="mono-search" />
        </template>

        <template #append>
          <q-icon
            v-if="currentRefinement !== ''"
            name="mono-cross"
            class="cursor-pointer"
            @click="currentRefinement = ''"
          />
          <q-icon name="mono-search" />
        </template>

        <template #loading>
          <slot name="loading-indicator" />
        </template> -->
      </SanFieldSearch>
    </slot>
  </div>
</template>

<script setup>
import { watch } from 'vue'
import { connectSearchBox } from 'instantsearch.js/es/connectors'// eslint-disable-line
import { useConnector } from '@/composables'

defineOptions({ name: 'SanSearchBox' })
const currentRefinement = defineModel('currentRefinement', { type: String, default: undefined })
const emit = defineEmits(['update:modelValue', 'focus', 'blur', 'clear'])
const props = defineProps({
  placeholder: { type: String, default: '' },
  autofocus: { type: Boolean, default: true },
  isLoading: { type: Boolean, default: false },
  submitTitle: { type: String, default: 'Submit the search query' },
  resetTitle: { type: String, default: 'Clear the search query' },
  value: { type: String, default: undefined },
  queryHook: { type: Function, default: undefined }
})

const state = useConnector(connectSearchBox, {
  $$widgetType: 'ais.searchBox'
})

if (props.value) {
  currentRefinement.value = props.value
}

watch(() => currentRefinement.value, val => {
  const query = val || props.value
  emit('update:modelValue', query)
  state.value?.refine(query)
})

</script>

<style lang="scss">
.san-searchbox {
  display: flex;
  align-items: center;

  .san-field-searchbox {
    padding: 0;
    width: 250px;

    .q-field__control {
      &::before {
        background: var(--q-background-mid);
      }
    }
  }
}
</style>
